module.exports = __webpack_public_path__ + "img/account.9960d83e.svg";